import { derived, writable } from "svelte/store";
import { fileStore } from "./select-files";
// Notification store
export const cartNotification = writable({
    show: false,
    count: 0,
    total: 0
});
// Separate store for CartAlert visibility
export const showCartAlert = derived(fileStore, $files => ($files.selectedFiles.length > 0));
// Define standard option order for consistency across the application
const standardOptionOrder = [
    "bbox",
    "stations",
    "startdate",
    "enddate",
    "includedocumentation",
    "datatypes",
    "includeattributes",
    "includestationlocation",
    "includestationname",
    "units"
];
function createCart() {
    const initialState = localStorage.getItem('cart') == null ? [] : JSON.parse(localStorage.getItem('cart'));
    const { set, subscribe, update } = writable(initialState);
    let notificationTimeout = null;
    return {
        subscribe,
        // Sort options in a standard order
        sortOrderOptions: (options) => {
            return [...options].sort((a, b) => {
                const indexA = standardOptionOrder.indexOf(a.id);
                const indexB = standardOptionOrder.indexOf(b.id);
                // If option isn't in our order list, put it at the end
                if (indexA === -1)
                    return 1;
                if (indexB === -1)
                    return -1;
                return indexA - indexB;
            });
        },
        addItem: (singleOrder) => update((state) => {
            const newState = [...state, singleOrder];
            localStorage.setItem("cart", JSON.stringify(newState));
            // Show notification
            if (notificationTimeout) {
                clearTimeout(notificationTimeout);
            }
            cartNotification.update((n) => ({
                show: true,
                count: n.show ? n.count + 1 : 1,
                total: newState.length
            }));
            fileStore.removeAll();
            // Set timer to hide notification
            notificationTimeout = setTimeout(() => {
                cartNotification.update((n) => ({
                    show: false,
                    count: 0,
                    total: n.total
                }));
            }, 5000);
            return newState;
        }),
        removeItem: (index) => update((state) => {
            state.splice(index, 1);
            const newState = [...state];
            localStorage.setItem('cart', JSON.stringify(newState));
            return newState;
        }),
        clear: () => {
            update((state) => {
                const newState = [];
                localStorage.setItem("cart", JSON.stringify(newState));
                return newState;
            });
        },
        dismissNotification: () => {
            if (notificationTimeout) {
                clearTimeout(notificationTimeout);
                notificationTimeout = null;
            }
            cartNotification.update((n) => ({
                show: false,
                count: 0,
                total: n.total
            }));
        }
    };
}
export const cart = createCart();
function createCartEmail() {
    const { set, subscribe, update } = writable(localStorage.getItem('email') == null ? '' : localStorage.getItem('email'));
    return {
        subscribe,
        set: (value) => {
            localStorage.setItem("email", value.toLowerCase());
            set(value);
        }
    };
}
export const cartEmail = createCartEmail();
